.summary-card {
    border-radius: 4px;
    border: 1px solid var(--off-white-md);
    background-color: var(--white);
}

.summary-header {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--off-white);
    padding: 0 12px;
    border-bottom: 1px solid var(--off-white-md);
}

.month-row {
    display: flex;
    justify-content: space-between;
    padding: 8px 12px;
    border-bottom: 1px solid var(--off-white-md);
}

.month-row:last-child {
    border-bottom: none;
}
